<app-manage-template [title]="'Manage User Access'" [COLUMNFIELDS]="columns" [userData]="(userDatas | async)"
    [parentData]="businessNetworkDetails" [KEY]="'USERS'" (updateParent)="updateBusinessNetwork($event)"
    [showCrown]="true" [dropdownContext]="filterData" (updateMembers)="updateBusinessNetworkMembers($event)"  
    [onSearch]="onSearch" [holder]="'Search by name or email '" [onFilter]="onFilter" [this]="this"
    [onScroll]="onScroll">

    <div class="row mt-1">
        <div class="col-xl-4 col-sm-4">
            <div class="card">
                <div class="card-body">
                    <div class="">
                        <div class="col-7"><span>Total Users</span>
                            <h1>{{totalUsersActual}}</h1>
                        </div>
                    </div>
                    <div class="progress-showcase">
                        <div class="progress sm-progress-bar ">
                            <div class="bg-primary progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0"
                                aria-valuemax="100" style="width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-sm-4">
            <div class="card">
                <div class="card-body">
                    <div class="">
                        <div class="col-7"><span>Utilized Users</span>
                            <h1>{{activetotalUsers}}</h1>
                        </div>
                    </div>
                    <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                            <div role="progressbar" aria-valuenow="25" aria-valuemin="0" class="progress-bar"
                                aria-valuemax="100" [ngClass]="getClassStyle(activetotalUsers , totalUsers)"
                                [ngStyle]="{ 'width' : getPercentage(activetotalUsers , totalUsers)}"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-sm-4">
            <div class="card">
                <div class="card-body">
                    <div class="">
                        <div class="col-7"><span>Available</span>
                            <h1>{{AvailableUsers}}</h1>
                        </div>
                    </div>
                    <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                            <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                                class="progress-bar" [ngClass]="getClassStyle(AvailableUsers, totalUsers)"
                                [ngStyle]="{ 'width' : getPercentage(AvailableUsers , totalUsers)}">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</app-manage-template>

<ng-template #turnoffUser let-modal>
    <div class="common-header-flex">
        <div>Transfer Credits  </div>
        <button>
            <span (click)="closeModal()" class="common-close">&times;</span>
        </button>
    </div>

    <div class="modal-body transferjobcandidatcount">

        <div class="container">
            <p *ngIf="!NoDatafroTransfer()">Please transfer the active Jobs / Candidates created by the user before
                removing access</p>

            <div *ngIf="NoDatafroTransfer()" class="display-grid">
                <ng-icon name="customEmpty"></ng-icon>
                <div> You don't have any candidate or jobs for the transfer</div>
            </div>

            <div *ngFor="let section of transferSections">
                <div class="row" *ngIf="responseTransfreUser?.[section.countKey] > 0">
                    <div class="col-md-4">
                        <label style="margin-bottom: 0px;">{{ section?.label }}</label>
                    </div>
                    <div class="col-md-2">
                        <span>{{ responseTransfreUser?.[section.countKey] }}</span>
                    </div>
                    <div class="col-md-6">
                        <ng-select class="gs-transfer-select" [multiple]="false" [items]="dropdownOptions[section.key]" [(ngModel)]="selectedUsers[section.key]"
                            [bindValue]="'userId'" [bindLabel]="'fullName'" [placeholder]="'Select user'">
     
    
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-control custom-radio flex">
                                    <img *ngIf="item.photo" class="img-show-hide" [src]="url + item.photo" />
                                    <div *ngIf="!item.photo">
                                        <div class="circleimg-show-hide"
                                            [style.background-color]="getColortwo(item.firstName, item.lastName)">
                                            <div class="circle-text">{{ getInitialstwo(item.firstName, item.lastName) }}
                                            </div>
                                        </div>
                                    </div>
                                    <label class="form-radio-label ml-2 custom-control-label">
                                        {{ item.fullName }}
                                    </label>
                                </div>
                            </ng-template>
                        </ng-select>
                        <div class="text-danger" *ngIf="transferClicked && !selectedUsers[section.key]" 
                            style="float: right; margin-right: 8px;">
                            Please select a user
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="modal-footer text-center" *ngIf="!NoDatafroTransfer()">
        <button type="button" class="btn btn-default w70 " (click)="closeModal()"> Cancel
        </button>
        <button type="button" class="btn btn-primary w70" (click)="transferUserData()">
            Transfer
        </button>
    </div>

</ng-template>